<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button class="btn btn-outline-success" *ngIf="laboratorio.Id > 0" type="button" (click)="onAddTecnico()"><i class="fa fa-file-o"></i> Nuevo Técnico</button>
            <button *ngIf="!visibilitySpinner" type="button" (click)="onSave()" class="btn btn-outline-success "><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" type="button" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>


    <div class="animated fadeIn container-fluid">
        <h4>{{editTitle}} Laboratorio</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <div class="card-body">

                        <div class="row">

                            <div class="form-group col-md-6">
                                <label class="col-form-label required-field" for="inpRazonSocial">Razón Social</label>
                                <input formControlName="RazonSocial" name="RazonSocial" title=""
                                       class="form-control" id="inpNombre" type="text" value="" [ngClass]="displayFieldCss('RazonSocial')" maxlength="150">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('RazonSocial','required')">
                                    La Razón Social es obligatoria
                                </div>
                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('RazonSocial','RazonSocial_duplicated')">
                                    La Razón Social indicada ya existe en la base de datos
                                </div>
                            </div>

                            <div class="form-group col-md-6">
                                <label class="col-form-label required-field" for="inpDireccion">Dirección</label>
                                <input formControlName="Direccion" name="Direccion" title=""
                                       class="form-control" id="inpDireccion" type="text" value="" [ngClass]="displayFieldCss('Direccion')" maxlength="150">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Direccion','required')">
                                    La Dirección es obligatoria
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpCodigoPostal">Código Postal</label>
                                <input formControlName="CodigoPostal" name="CodigoPostal" title="" numbersOnly
                                       class="form-control" id="inpCodigoPostal" type="text" value="" [ngClass]="displayFieldCss('CodigoPostal')" maxlength="5">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('CodigoPostal','required')">
                                    El Código Postal es obligatorio
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="">Comunidad Autónoma</label>
                                <ng-select loadingText="Cargando..."
                                           [items]="listComunidad"
                                           bindLabel="Descripcion"
                                           bindValue="Id"
                                           formControlName="IdComunidadAutonoma"
                                           [loading]="!(listComunidad)"
                                           notFoundText="Comunidad Autónoma no encontrada"
                                           [ngClass]="displayFieldCssNgSelect('IdComunidadAutonoma')"
                                           placeholder="-- Seleccione una Comunidad Autónoma --"
                                           clearAllText="Eliminar selección"
                                           (change)="onSelectComunidad()">
                                </ng-select>
                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdComunidadAutonoma','required')">
                                    La Comunidad Autónoma es obligatoria
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="intProvincia">Provincia</label>
                                <ng-select loadingText="Cargando..."
                                           [items]="listProvincia"
                                           [readonly]="!listProvincia || listProvincia.length === 0"
                                           bindLabel="Descripcion"
                                           bindValue="Id"
                                           formControlName="IdProvincia"
                                           [loading]="(!(listProvincia) && (form.value.IdComunidadAutonoma > 0))"
                                           notFoundText="Provincia no encontrada"
                                           placeholder="-- Seleccione una Provincia --"
                                           clearAllText="Eliminar selección"
                                           (change)="onSelectProvincia()">
                                </ng-select>
                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdProvincia','required')">
                                    La Provincia es obligatoria
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="">Municipio</label>
                                <ng-select loadingText="Cargando..."
                                           [items]="listMunicipio"
                                           [readonly]="!listMunicipio || listMunicipio.length === 0"
                                           bindLabel="Descripcion"
                                           bindValue="Id"
                                           formControlName="IdMunicipio"
                                           [loading]="(!(listMunicipio) && (form.value.IdProvincia > 0))"
                                           notFoundText="Municipio no encontrado"
                                           placeholder="-- Seleccione un Municipio --"
                                           clearAllText="Eliminar selección">
                                </ng-select>
                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdMunicipio','required')">
                                    El Municipio es obligatorio
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpNombrePersonaContacto">Nombre Persona Contacto</label>
                                <input formControlName="NombrePersonaContacto" name="NombrePersonaContacto" title=""
                                       class="form-control" id="inpNombrePersonaContacto" type="text" value="" maxlength="150">
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpNombrePersonaContacto">Apellidos Persona Contacto</label>
                                <input formControlName="ApellidosPersonaContacto" name="ApellidosPersonaContacto" title=""
                                       class="form-control" id="inpApellidos" type="text" value="" maxlength="250">
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="">Email Persona Contacto</label>
                                <input formControlName="EmailPersonaContacto" name="EmailPersonaContacto" title=""
                                       class="form-control" id="" type="text" [ngClass]="displayFieldCss('EmailPersonaContacto')" value="" maxlength="250">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('EmailPersonaContacto','required')">
                                    El Email es obligatorio
                                </div>

                                <div class="invalid-feedback" *ngIf="isFieldInvalid('EmailPersonaContacto','email')">
                                    Formato incorrecto
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpTelefonoPersonaContacto">Teléfono Persona Contacto</label>
                                <input formControlName="TelefonoPersonaContacto" name="TelefonoPersonaContacto" title=""
                                       class="form-control" id="TelefonoPersonaContacto" type="text" value="" maxlength="50">
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpActivo">Activo</label>
                                <p-toggleButton class="form-control-togglebutton" formControlName="Activo" onLabel="Sí" offLabel="NO" onIcon="pi pi-check" offIcon="pi pi-times"></p-toggleButton>
                            </div>

                            <div class="form-group col-md-12">
                                <label class="col-form-label" for="inpObservaciones">Observaciones</label>
                                <textarea style="resize:none" formControlName="Observaciones" name="Observaciones" title=""
                                          class="form-control" id="inpObservaciones" type="text" value="" maxlength="5000"></textarea>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            <!--TECNICOS-->
            <div class="col-md-6">

                <div class="card card-accent-success animated fadeIn">

                    <div class="card-header-buscador">
                        <i class="fa fa-plus"></i> <strong id="stAduana">Técnicos Autorizados</strong>
                        <label class="col-form-label" for="stTecnico"></label>
                    </div>
                    <div class="card-body-detalle-list">

                        <div class="row">

                            <div class="col-md-12">
                                <table class="table table-list table-responsive table-sm">
                                    <thead>
                                        <tr>
                                            <th class="cabecerasTablaDetalles col-md-2"></th>
                                            <!--<th class="cabecerasTablaDetalles"></th>-->
                                            <th class="cabecerasTablaDetalles col-md-3">DNI</th>
                                            <th class="cabecerasTablaDetalles col-md-5">Nombre</th>
                                            <th class="cabecerasTablaDetalles col-md-2">Activo</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of laboratorio.TwRegTecnicoLaboratorioCollection">
                                            <td scope="col" class="col-md-2">
                                                <div class="btn-group">
                                                    <button type="button" (click)="onEditTecnico(item)" title="Consultar"
                                                            class="btn btn-sm btn-info">
                                                        <i class="fa fa-search"></i>
                                                    </button>
                                                </div>
                                                <!--RDLF: en principio no se borran tecnicos, se 'desactivan'-->
                                                <!--<div class="btn-group">
                                                    <button type="button" (click)="onDeleteTecnico(item)"
                                                            class="btn btn-sm btn-info">
                                                        <i class="fa fa-remove"></i>
                                                    </button>
                                                </div>-->
                                            </td>

                                            <td scope="col" class="col-md-3">{{item.NifUsuario}}</td>
                                            <td scope="col" class="col-md-5">{{item.NombreUsuario}} {{item.ApellidosUsuario}}</td>
                                            <td scope="col" class="col-md-2">{{item.Activo | siNo}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    </div>
</form>
